import React from 'react'
import { FormattedMessage } from 'react-intl'

export default function SearchIndicator() {
  return (
    <button className="search-instructions instructions btn btn-default btn-lg btn-block">
      <div className="search-instructions-icon icon">
        <i className="fa fa-search" />
      </div>
      <div>
        <FormattedMessage id="searchLabelExplanation" />
      </div>
    </button>
  )
}
